/* eslint-disable import/no-anonymous-default-export */
import React, { useRef, useState } from 'react';
import { Button, useTheme, Icon, Popover } from '@mui/material';
import { get, size } from 'global/lib/lodash';
import useStyles from './styles';
import { getColorFromScore } from 'global/styles';
import getDisplayScoreLabel from 'global/utils/getDisplayScore';
import clsx from 'clsx';

export default (props) => {
  const variant = get(props, 'variant', 'normal');
  const options = get(props, 'options', []);
  const scorecardConfig = get(props, 'scorecardConfig');
  const getHighlight = get(props, 'getHighlight', null);
  const { selected } = props;
  const theme = useTheme();
  const classes = useStyles({ variant });
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef();
  const ignoreConfigColor = get(scorecardConfig, 'ignoreColor', true);

  const open = Boolean(anchorEl);

  const btnPress = (e, opt, i) => {
    const onPress = get(props, 'onSelect', () => 0);
    onPress(opt, i);
    setAnchorEl(null);
  };

  const getColorFromValue = (val, isSelected = false) => {
    const color = getColorFromScore(val, scorecardConfig && !ignoreConfigColor ? [scorecardConfig.minScore || 0, scorecardConfig.maxScore || 100] : undefined);
    return {
      borderColor: color,
      backgroundColor: isSelected ? color : undefined,
      color: isSelected ? theme.palette.getContrastText(color) : undefined,
    };
  };

  const getIconFromIndex = (i) => {
    const icons = ['close', 'check', 'indeterminate_check_box'];
    return icons[i];
  };

  if (size(options) > 6) {
    const currentSel = !(selected >= 0) ? options.find(o => get(o,'value') === selected) : options[selected];
    const buttonTextContentFirst = get(currentSel, 'criteria', '');

    return (
      <div className={classes.container}>
        <Button
          ref={buttonRef}
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={(e) => setAnchorEl(buttonRef.current)}
          style={getColorFromValue(get(currentSel, 'value'), currentSel)}
          className={clsx(classes.btn, classes.btnSelected)}
        >
          <span className={classes.optNumber}>{getDisplayScoreLabel(currentSel, selected, scorecardConfig, true)}</span>
          <span className={classes.btnText}>{getHighlight ? getHighlight(buttonTextContentFirst) : buttonTextContentFirst}</span>
          <span style={{ marginLeft: 'auto', marginTop: 5 }}>
            <Icon>arrow_drop_down</Icon>
          </span>
        </Button>

        <Popover
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            horizontal: 0,
            vertical: 0,
          }}
          elevation={0}
        >
          <div style={{ width: get(anchorEl, 'clientWidth', 0) + 5 }}>
            {options.map((opt, i) => {
              const isSelected = opt.index === selected;
              const buttonTextContent = get(opt,'criteria','');
              return (
                <Button key={i} onClick={(e) => btnPress(e, opt, opt.index)} style={getColorFromValue(opt.value, isSelected)} className={clsx(classes.btn, isSelected && classes.btnSelected)}>
                  <span className={classes.optNumber}>{getDisplayScoreLabel(opt, i, scorecardConfig, true)}</span>
                  <span className={classes.btnText}>{getHighlight ? getHighlight(buttonTextContent) : buttonTextContent}</span>
                </Button>
              );
            })}
          </div>
        </Popover>
      </div>
    );
  }

  const isDisabled = get(props, 'isDisabled', false);

  return (
    <div className={classes.container} style={isDisabled ? { pointerEvents: 'none' } : {}}>
      {options.map((opt, i) => {
        const isSelected = opt.index === selected;
        const isActiveWrap = props.isActive !== undefined && get(props, 'isActive.value') == opt.index;
        const isCompareWrap = props.isCompare !== undefined && get(props, 'isCompare.value') == opt.index;
        // if it's pass/fail style, prioritize criteria for button text, then label; else use label
        const buttonTextContent = variant === 'passFail' ? (get(opt,'criteria') || get(opt,'label') || getDisplayScoreLabel(opt,i,scorecardConfig,true)) : get(opt,'criteria','');
        return (
          <div key={i} style={{ width: '100%' }} className={clsx((isActiveWrap || isCompareWrap) && classes.activeWrap)}>
            <Button onClick={(e) => btnPress(e, opt, opt.index)} style={getColorFromValue(opt.value, isSelected)} className={clsx(classes.btn, isSelected && classes.btnSelected)}>
              {variant === 'passFail' ? <Icon className={classes.icon}>{getIconFromIndex(i)}</Icon> : <span className={classes.optNumber}>{getDisplayScoreLabel(opt, i, scorecardConfig,true)}</span>}
              <span className={classes.btnText}>{getHighlight ? getHighlight(buttonTextContent) : buttonTextContent}</span>
            </Button>
            {(isActiveWrap && isCompareWrap) ? <span className='activetext'>{`your score & ${get(props,'isCompare.text') || 'target'}`}</span>
              : isActiveWrap ? <span className='activetext'>your score</span>
              : isCompareWrap ? <span className='activetext'>{`${get(props,'isCompare.text') || 'target'} score`}</span> : undefined
            }
          </div>
        );
      })}
    </div>
  );
};
